<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group
                label="Nome"
                label-for="v-name"
              >
                <b-form-input
                  id="v-name"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!form.id) ||
                      (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="12"
            lg="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Tipo Evento"
              rules="required"
            >
              <b-form-group
                label="Tipo Evento"
                label-for="v-tipoEvento"
              >
                <v-select
                  v-model="form.tipoEvento.id"
                  :reduce="(comboTipoEvento) => comboTipoEvento.id"
                  label="nome"
                  :options="comboTipoEvento"
                  :state="errors.length > 0 ? false : null"
                  data-cy="tipo"
                  :disabled="
                    (!verificarPermissao('ROLE_ATEND_ATUALIZAR') &&
                      !!form.id) ||
                      (!verificarPermissao('ROLE_ATEND_INSERIR') && !form.id)
                  "
                />
                <small
                  data-cy="v-especialidade"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Desctição"
              label-for="v-description"
            >
              <b-form-textarea
                id="v-description"
                v-model="form.descricao"
                placeholder="Digite aqui uma descrição"
                :disabled="
                  (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') && !!form.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                "
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="local"
              rules="required"
            >
              <b-form-group
                label="Local"
                label-for="v-local"
              >
                <b-form-input
                  id="v-local"
                  v-model="form.local"
                  :state="errors.length > 0 ? false : null"
                  placeholder="local"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!form.id) ||
                      (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Data Inicial"
              label-for="v-dataInicial"
            >
              <flat-pickr
                v-model="form.dataInicial"
                name="fieldDate"
                class="form-control"
                :config="{
                  altInput: true,
                  altFormat: 'd/m/Y',
                  enableTime: false,
                  dateFormat: 'Y-m-d\\TH:i:ss\\Z',
                }"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Data Final"
              label-for="v-dataFinal"
            >
              <flat-pickr
                v-model="form.dataFinal"
                name="fieldDate"
                class="form-control"
                :config="{
                  altInput: true,
                  altFormat: 'd/m/Y',
                  enableTime: false,
                  dateFormat: 'Y-m-d\\TH:i:ss\\Z',
                }"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Hora"
              rules="required"
            >
              <b-form-group
                label="Hora"
                label-for="v-hora"
              >
                <flat-pickr
                  v-model="form.hora"
                  name="fieldDate"
                  :config="{
                    altInput: true,
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true,
                  }"
                />
                <small
                  data-cy="v-hora-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Hora Final"
              rules="required"
            >
              <b-form-group
                label="Hora Final"
                label-for="v-horaFinal"
              >
                <flat-pickr
                  v-model="form.horaFinal"
                  name="fieldDate"
                  :config="{
                    altInput: true,
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    time_24hr: true,
                  }"
                />
                <small
                  data-cy="v-horaFinal-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Quantidade de Vagas"
              label-for="v-vagas"
            >
              <b-form-input
                id="v-vagas"
                v-model="form.qtoVagas"
                type="number"
                placeholder="vagas"
                :disabled="!!$route.params.id"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="publicoAlvo"
              rules="required"
            >
              <b-form-group
                label="Publico Alvo"
                label-for="v-publicoAlvo"
              >
                <b-form-input
                  id="v-publicoAlvo"
                  v-model="form.publicoAlvo"
                  :state="errors.length > 0 ? false : null"
                  placeholder="publicoAlvo"
                  :disabled="
                    !verificarPermissao('ROLE_ADMIM_ATUALIZAR') ||
                      !verificarPermissao('ROLE_ADMIM_INSERIR')
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="status"
              rules="required"
            >
              <b-form-group
                label="Status"
                label-for="v-status"
              >
                <v-select
                  v-model="form.status"
                  :reduce="(comboStatus) => comboStatus.value"
                  label="label"
                  :options="comboStatus"
                  :state="errors.length > 0 ? false : null"
                  data-cy="status"
                  :disabled="
                    !verificarPermissao('ROLE_ADMIM_ATUALIZAR') ||
                      !verificarPermissao('ROLE_ADMIM_INSERIR')
                  "
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Valor"
              label-for="valor"
            >
              <money
                id="valor"
                v-model="form.valor"
                v-bind="money"
                class="form-control"
                placeholder="0,00"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Tem Cobrança"
              label-for="v-temCobranca"
            >
              <b-form-checkbox
                v-model="form.temCobranca"
                :checked="form.temCobranca"
                name="check-button"
                switch
                inline
                :disabled="
                  !verificarPermissao('ROLE_ADMIM_ATUALIZAR') ||
                    !verificarPermissao('ROLE_ADMIM_INSERIR')
                "
              >
                {{ form.temCobranca ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Ativo"
              label-for="v-ativo"
            >
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') && !!form.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                "
              >
                {{ form.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <b-col cols="12">
            <ButtonsFormVue
              :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
              :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
              :disable-form="false"
              @save="save()"
              @cancel="cancel()"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { formatDate } from '@/utils/dateFormatter'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import { Money } from 'v-money'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('eventSettingsModule', {
      event: state => state.event,
    }),
    ...mapState('combosModule', {
      comboTipoEvento: state => state.comboTipoEvento,
    }),
  },
  components: {
    Money,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
    vSelect,
    flatPickr,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Eventos',
      required,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      form: {
        nome: '',
        descricao: '',
        tipoEvento: {
          id: null,
          nome: '',
          ativo: true,
        },
        local: '',
        dataInicial: '',
        dataFinal: '',
        hora: null,
        horaFinal: null,
        qtoVaga: 0,
        publicoAlvo: '',
        status: '',
        ativo: true,
        temCobranca: false,
        valor: 0,
        tipoPagamentoRecebimento: {
          id: null,
          descricao: '',
        },
      },
      comboStatus: [
        {
          value: 'CANCELADO',
          label: 'Cancelado',
        },
        {
          value: 'ACONTECENDO',
          label: 'Acontecendo',
        },
        {
          value: 'FINALIZADO',
          label: 'Finalizado',
        },
        {
          value: 'PLANEJADO',
          label: 'Planejado',
        },
      ],
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.event))
    this.$store.dispatch('combosModule/loadComboTipoEvento')
  },
  methods: {
    async save() {
      try {
        this.$refs.form.validate().then(success => {
          if (success) {
            // Formatar as datas antes de enviar
            const formattedData = {
              ...this.form,
              dataInicial: formatDate(this.form.dataInicial),
              dataFinal: formatDate(this.form.dataFinal),
            }

            if (this.form.id) {
              this.$store
                .dispatch('eventSettingsModule/editEvent', formattedData)
                .then(response => {
                  if (response.response) {
                    this.MensagemError(
                      'Falha ao Editar',
                      response.response.data.error,
                    )
                    return
                  }
                  this.showMessageSuccess('Editar', 'Editado com sucesso!')
                  this.$refs.form.reset()
                  this.cancel()
                })
            } else {
              this.$store
                .dispatch('eventSettingsModule/insertNewEvent', formattedData)
                .then(response => {
                  if (response.response) {
                    this.MensagemError(
                      'Falha ao Inserir',
                      response.response.data.error,
                    )
                    return
                  }

                  if (response.error) {
                    this.MensagemError('Falha ao Inserir', response.message)
                    return
                  }
                  this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                  this.cleanObjeto()
                  this.$store.dispatch('eventSettingsModule/resetEvent')
                  this.$refs.form.reset()
                })
            }
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('eventSettingsModule/resetEvent')
    },
    cleanObjeto() {
      this.form = {
        nome: '',
        descricao: '',
        tipoEvento: {
          id: null,
          nome: '',
          ativo: true,
        },
        local: '',
        dataInicial: '',
        dataFinal: '',
        hora: null,
        horaFinal: null,
        qtoVaga: 0,
        publicoAlvo: '',
        status: '',
        ativo: true,
        temCobranca: false,
        valor: 0,
        tipoPagamentoRecebimento: {
          id: null,
          descricao: '',
        },
      }
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<!-- Se tiver cobrança habilitar valor e tipo de cobrança
ABA descontos so aparece se tiver cobrança
aba participante
responsavel pelo evento
Tarefas do evento -->
